import { language } from '@tencent/ppd-base-libs';

const lang = getMapLang();

/**
 * 语言映射
 */
function getMapLang(): string {
  const LANG_MAP = {
    'zh-cn': 'cn',
    'zh-hk': 'hk',
    en: 'en',
  };
  return LANG_MAP[language.getLanguage()] || 'hk';
}

/**
 * 根据多语言相应配置字符串信息
 * @param obj
 * @returns
 */
export function getLanStrVal(obj) {
  if (!obj) return '';
  return obj[lang] as string;
}

/**
 *  数组随机排序
 * @param array
 * @returns
 */
export function shuffle<T>(array: T[]) {
  const list = array.concat();
  let currentIndex = list.length;
  let temporaryValue: T;
  let randomIndex: number;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = list[currentIndex];
    list[currentIndex] = list[randomIndex];
    list[randomIndex] = temporaryValue;
  }
  return list;
}
